export class Eyedrop {
  constructor(drawID) {
    this.drawID = drawID;
  }
}
